import PropTypes from "prop-types";

export const PopupContainerProps = {
    buttonStyle: PropTypes.string,
    order: PropTypes.object.isRequired,
    store_id: PropTypes.number.isRequired,
};

export const PopupProps = {
    ...PopupContainerProps,
    open: PropTypes.bool.isRequired,
    state: PropTypes.object.isRequired,
    onClose: PropTypes.func.isRequired,
    onRedirect: PropTypes.func.isRequired,
};
